import { render, staticRenderFns } from "./RecordVoice.vue?vue&type=template&id=1293f1ef&scoped=true"
import script from "./RecordVoice.vue?vue&type=script&lang=js"
export * from "./RecordVoice.vue?vue&type=script&lang=js"
import style0 from "./RecordVoice.vue?vue&type=style&index=0&id=1293f1ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293f1ef",
  null
  
)

export default component.exports